import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-infra/approach_infra.webp";
import {
  CloudMigCloudApp,
  CloudMigDataware,
  CloudMigSec,
  CloudMigOpt,
} from "../../../app-constants";

function Comprehensivecloud() {
  return (
    <section
      className="comprehensive_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Our Approach to Managing Cloud Infrastructure</h2>
            <p style={{ color: "#fff" }}>
              As a leading cloud infrastructure management company, we use a
              systematic strategy to ensure efficient cloud management to suit
              the changing demands of organizations of all sizes.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigCloudApp}</div>
                    <div className="compre_head">
                      <h5>Strategic Cloud Migration</h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      We assess your present infrastructure as well as your
                      business goals to build an appropriate cloud migration
                      plan. We accelerate your path to market by picking the
                      cloud platform most suited to your requirements matrix and
                      using built-in functionalities as well as managed PaaS to
                      reduce architectural and operations overhead costs.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigDataware}</div>
                    <div className="compre_head">
                      <h5>Innovative Cloud Architecture</h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      Our specialty is building scalable, resilient
                      microservices architectures that improve flexibility. To
                      maximize resource allocation and guarantee smooth
                      application deployment and administration across various
                      cloud environments, we give priority to transformed
                      services.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigSec}</div>
                    <div className="compre_head">
                      <h5>Automated Infrastructure Management</h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      Our dedicated DevOps teams apply the IaC  (infrastructure
                      as Code) approach to ensure that all the necessary cloud
                      setups are handled automatically. We use strategies like
                      auto-scaling to proactively add or reduce the number of
                      resources needed based on the load to help reduce overhead
                      and improve resource utilization efficiency.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigOpt}</div>
                    <div className="compre_head">
                      <h5>Continuous Optimization</h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      We constantly use a preventive strategy to maintain and
                      improve your cloud environment. This entails tuning and
                      optimizing various settings, planning and executing cost
                      optimization strategies, and strengthening security
                      measures to keep your cloud environment efficient for
                      business growth and innovation.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
               Migrate to Cloud
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Comprehensivecloud;
